import { AppThunk } from '../../../store/rootReducer';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import { DiagnosticDelineationSave } from '../types/analytics.types';
import { getBaseProperties, track } from '../analytics.utils';

export const trackEachSaveButton =
  (name: DiagnosticDelineationSave, sendToAnalytics = track): AppThunk =>
  (_, getState) => {
    const display_save_diagnostic = booleanPreferenceSelector(
      'allowSaveDiagnostic',
    )(getState());
    const display_save_delineation = booleanPreferenceSelector(
      'allowSaveDelineation',
    )(getState());
    const baseProperties = getBaseProperties(getState);
    if (baseProperties == null) {
      return null;
    }
    const { ecgId, userId, view } = baseProperties;

    sendToAnalytics({
      name,
      properties: {
        user_id: userId,
        view,
        ecg_id: ecgId,
        display_save_diagnostic,
        display_save_delineation,
      },
    });
  };
